import {
  AutocompleteInput,
  Create,
  Datagrid,
  Edit,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  useCreate,
  useMutation,
  useQuery,
  useRedirect,
  useNotify,
  useRefresh,
} from 'react-admin';
import React, { useEffect } from "react";
import Container from '@material-ui/core/Container';
import { Card, CardContent, CardHeader } from "@material-ui/core";
import { useForm, useFormState } from "react-final-form"
import WhenFieldChanges from './whenFieldChanges';

export const RuleDefinitionList = props => (
  <List {...props} >
    <Datagrid rowClick="edit">
      <TextField source="id"/>
      <TextField source="name"/>
      <ReferenceField label="Project" reference="Project" source="project.id" link={false} sortable={false}>
        <TextField source="name"/>
      </ReferenceField>


      <ReferenceField label="Condition Record Type" reference="RecordType" source="conditionRecordType.id" link={false}
                      sortable={false}>
        <TextField source="name"/>
      </ReferenceField>
      <ReferenceField label="Condition Description" reference="Description" source="conditionDescription.id"
                      link={false} sortable={false}>
        <TextField source="name"/>
      </ReferenceField>

      <TextField label="Condition Value" source="conditionListValue.value" sortable={false}/>

      <TextField label="Type" source="type" sortable={false}/>
      
      <ReferenceField label="Action Record Type" reference="RecordType" source="actionRecordType.id" link={false}
                      sortable={false}>
        <TextField source="name"/>
      </ReferenceField>
      <ReferenceField label="Action Description" reference="Description" source="actionDescription.id" link={false}
                      sortable={false}>
        <TextField source="name"/>
      </ReferenceField>

      <TextField label="Action value" source="actionListValue.value" sortable={false}/>
    </Datagrid>
  </List>
);


export const RuleDefinitionCreateView = props => {

  const [create] = useCreate('RuleDefinitionListValue');
  const redirectTo = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async values => {
    const {
      type,
      _condition_description,
      _condition_child_list_value,
      _action_list_value_id,
      _action_description,
      name
    } = values;

    let newRuleDef;
    if (type === 'CHILD_ALL' || type === 'CHILD_ANY') {
      newRuleDef = {
        parent_description_id: _action_description,
        parent_list_value_id: _action_list_value_id,
        child_description_id: _condition_description,
        child_list_value_id: _condition_child_list_value,
        type,
        link_relationship: null,
        order: 0,
        name,
      }
    } else {
      newRuleDef = {
        parent_description_id: _condition_description,
        parent_list_value_id: _condition_child_list_value,
        child_description_id: _action_description,
        child_list_value_id: _action_list_value_id,
        type,
        link_relationship: null,
        order: 0,
        name,
      }
    }
    await create({ payload: { data: { createRuleDefinitionListValueInput: newRuleDef } } });
    notify(`Changes saved`)
    redirectTo('/RuleDefinitionListValue');
    refresh();
  }

  return (
    <Create title='Create Workflow Rule' {...props}>
      <SimpleForm save={handleSubmit} redirect="list">
        <RuleDefinitionEditOrCreate/>
      </SimpleForm>
    </Create>
  );
};


const RuleDefinitionEditOrCreate = (props) => {

  // The form for editing/creating a record
  const formState = useFormState();
  const form = useForm();

  // The existing record
  const { record } = props;


  useEffect(() => {
    if (!record?.id) {
      form.reset();
      return;
    }
    form.reset({
      id: record.id,
      _project: record.project.id,
      _on_condition_record_type: record.conditionRecordType.id,
      _condition_description: record.conditionDescription.id,
      _condition_child_list_value: record.conditionListValue.id,
      _on_action_record_type: record.actionRecordType.id,
      _action_description: record.actionDescription.id,
      _action_list_value_id: record.actionListValue.id,
    });

  }, [record])


  const {
    _project,
    _on_condition_record_type,
    _condition_description,
    _action_description,
    _on_action_record_type
  } = formState.values;


  const projectSearch = (n) => {
    if (n && n.length >= 3) {
      return {
        name__like: n,
      }
    }
  }

  const { data: onConditionDescription } = useQuery({
    type: 'getOne',
    resource: 'Description',
    payload: { id: _condition_description }
  }, {
    enabled: _condition_description > 0
  });

  const { data: onActionDescription } = useQuery({
    type: 'getOne',
    resource: 'Description',
    payload: { id: _action_description }
  }, {
    enabled: _action_description > 0
  });

  return (
    <Container maxWidth="sm">

      <ReferenceInput label="Project" source="_project" reference="Project" filterToQuery={projectSearch}
                      enabled={!!record?.project?.id}>
        <AutocompleteInput optionText="name" source={"id"} enabled={!!record?.project?.id}/>
      </ReferenceInput>
      <WhenFieldChanges field="_project" set="_on_condition_record_type"/>

      <TextInput source="name"/>

      <Card variant={'outlined'}>
        <CardHeader title="When this happens"/>
        <CardContent>

          <SelectInput source="type" choices={[
            { id: 'CHILD_ANY', name: 'When any child' },
            { id: 'CHILD_ALL', name: 'When all children' },
            { id: 'ON_PARENT_CHANGE', name: 'When the parent' },
          ]} label='Scope'/>

          <div>
            <ReferenceInput label="Of type" source="_on_condition_record_type" reference="RecordType" perPage={500}
                            filter={{ project_id: _project || undefined }}>
              <SelectInput optionText="name" 
              />
            </ReferenceInput>
            <WhenFieldChanges field="_on_condition_record_type" set="_condition_description"/>
          </div>

          <div>
            {_on_condition_record_type && <ReferenceInput label={"description"}
                                                          source="_condition_description" reference="Description"
                                                          perPage={1000}
                                                          filter={{
                                                            projectId: _project || undefined,
                                                            recordTypeId: _on_condition_record_type || undefined,
                                                            fk_list__gt: 0
                                                          }}>
              <SelectInput optionText="name" />
            </ReferenceInput>}
            <WhenFieldChanges field="_condition_description" set="_condition_child_list_value"/>
          </div>

          <div>
            {onConditionDescription &&
            <SelectInput label="matches value" optionText="value" choices={onConditionDescription.listValues}
                         source={"_condition_child_list_value"} />}
          </div>

        </CardContent>
      </Card>
      <Card variant={'outlined'}>
        <CardHeader title="Do this"/>
        <CardContent>
          <div>
            <ReferenceInput label="To types" source="_on_action_record_type" reference="RecordType"
                            perPage={500} filter={{ project_id: _project || undefined }}>
              <SelectInput optionText="name" />
            </ReferenceInput>
            <WhenFieldChanges field="_on_action_record_type" set="_action_description"/>
          </div>
          <div>
            {_on_action_record_type && <ReferenceInput
              label={"description"}
              source="_action_description" reference="Description"
              perPage={1000}
              filter={{
                projectId: _project || undefined,
                recordTypeId: _on_action_record_type || undefined,
                fk_list__gt: 0
              }}>
              <SelectInput optionText="name" />
            </ReferenceInput>}
          </div>
          <div>
            {onActionDescription &&
            <SelectInput label="matches value" optionText="value" choices={onActionDescription.listValues}
                         source={"_action_list_value_id"} />}
          </div>
        </CardContent>
      </Card>
    </Container>
  )
}


export const RuleDefinitionEditView = props => {
  const [mutate] = useMutation();
  const redirectTo = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();
  const handleSubmit = async values => {
    const {
      id,
      type,
      _condition_description,
      _condition_child_list_value,
      _action_list_value_id,
      _action_description,
      name
    } = values;

    let updatedRuleDef;
    if (type === 'CHILD_ALL' || type === 'CHILD_ANY') {
      updatedRuleDef = {
        parent_description_id: _action_description,
        parent_list_value_id: _action_list_value_id,
        child_description_id: _condition_description,
        child_list_value_id: _condition_child_list_value,
        type,
        link_relationship: null,
        order: 0,
        name,
      }
    } else {
      updatedRuleDef = {
        parent_description_id: _condition_description,
        parent_list_value_id: _condition_child_list_value,
        child_description_id: _action_description,
        child_list_value_id: _action_list_value_id,
        type,
        link_relationship: null,
        order: 0,
        name,
      }
    }

    await mutate({ type: 'update', resource: 'RuleDefinitionListValue', payload: { data: { id, updateRuleDefinitionListValueInput: updatedRuleDef } } });
    notify('Saved');
    redirectTo('/RuleDefinitionListValue');
    refresh()
  }
  return (
    <Edit {...props}>
      <SimpleForm redirect="list" save={handleSubmit}>
        <RuleDefinitionEditOrCreate/>
      </SimpleForm>
    </Edit>
  )
}
